const GRADE_ORDER = ['PRE', 'EC', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

/**
 * Display labels for the dashboard; the survey stores the codes on the left. Kept here so the
 * chart axis and the Grades column read identically.
 */
const GRADE_LABEL: Record<string, string> = {
  PRE: 'Pre-S',
  EC: 'Pre-K',
  K: 'K',
  1: '1st',
  2: '2nd',
  3: '3rd',
  4: '4th',
  5: '5th',
  6: '6th',
  7: '7th',
  8: '8th',
  9: '9th',
  10: '10th',
  11: '11th',
  12: '12th'
}

export const gradeLabel = (key: string): string => GRADE_LABEL[key] ?? key

export const compareGrades = (a: string, b: string): number => GRADE_ORDER.indexOf(a) - GRADE_ORDER.indexOf(b)

export const formatGrades = (grades: string): string =>
  grades.split(',').map(g => g.trim()).filter(Boolean)
    .sort(compareGrades)
    .map(gradeLabel).join(', ')
